import { createStore } from "vuex";
import Vue             from "vue";
import axios           from "axios";
import { flatMap }     from "lodash-es";


axios.defaults.headers.common = {
    'X-Requested-With' : 'XMLHttpRequest',
    'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
};

let state =
        {
            chatbot        : [],
        };

let getters =
        {

        };


let actions =
        {

        }


let mutations =
        {

        }


export default createStore( { state, getters, actions, mutations } );

